import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { FacialRecognitionState, FacialRecognitionStore } from './facial-recognition.store';

@Injectable({ providedIn: 'root' })
export class FacialRecognitionQuery extends QueryEntity<FacialRecognitionState> {
  constructor(protected store: FacialRecognitionStore) {
    super(store);
  }
}
